module.exports = __webpack_public_path__ + "media/images/vp/samples/01-dc78bce7df77ac8d83f126945dd5abca.jpg";